// TODO: Define what is a valid email body
export const isValidBody = (body: string): boolean => {
  //INFO: deleting the email body and writing a new one is valid
  // we are allowed to store an empty string int he redux store, it just needs to be a string
  return typeof body === "string";
};
